import React from 'react';
import LoseBase from '../components/base/lose-base';

const ChampionshipRulesLose = () => {
  return <LoseBase sportType="general" />;
};

export default ChampionshipRulesLose;
